<script>
</script>
<!-- Main -->
  <div id="main" class="container">
<!-- Three -->
  <section id="three" class="feature">
    <div class="row">
      <div class="col-6 col-12-medium">
        <div class="box alt">
          <div class="row gtr-uniform gtr-50">
            <div class="col-12 col-12-xsmall">
              <a href={"javascript:void(0)"} class="image fit">
                <img src="images/courseThumbnail.png" alt="" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 col-12-medium imp-medium">
        <h2>Summit Cases</h2>
        <p>Get access to all 12 sessions from the Spine Management Summit 2023, plus ongoing weekly Summit Rounds. Up to 22 hours CME credit.</p>
        <ul class="actions">
          <li><a href="/#/create" class="button">Subscribe</a></li>
        </ul>
      </div>
    </div>
  </section>
</div>


<style>
/* Section Three */
#three a.button {
  background-color: #68b5cf !important;
  color: #fff !important;
  border: none;
}
#three a.button:hover, #three a.button:active {
  background-color: #1c1d1e !important;
  color: #fff !important;
  box-shadow: none;
}

#main {
  min-height: calc(100vh - 32.3em);
  padding-top: 3.5em;
  padding-bottom: 3.5em;
}
</style>
